<template>
  <div>
    <!-- Alert: No item found -->
    <b-breadcrumb class="breadcrumb-slash mb-1">
      <b-breadcrumb-item :to="{ name: 'seller-list' }">
        ข้อมูลร้านค้า (ผู้ขาย)
      </b-breadcrumb-item>
      <b-breadcrumb-item active>
        ดูข้อมูล
      </b-breadcrumb-item>
    </b-breadcrumb>
    <template v-if="userDatas">
      <!-- First Row -->
      <b-row>
        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
        >
          <user-view-user-info-card :user-data="userDatas" />
        </b-col>
      </b-row>

      <b-row>
        <b-col
          cols="12"
          lg="6"
        >
          <user-view-user-permissions-card :user-data="userDatas" />
        </b-col>
        <b-col
          cols="12"
          lg="6"
        >
          <user-view-user-timeline-card :user-data="userDatas" />
        </b-col>
      </b-row>

      <b-row class="pl-1 pr-1">
        <b-col
          cols="12"
          style="background-color: #fff"
        >
          <b-card>
            <b-card-header
              class="col-12 pt-2 pb-2"
            >
              <h4>
                ข้อมูลสินค้า
              </h4>

            </b-card-header>
            <b-card-body
              class="col-12"
            >
              <b-table
                :items="productList"
                responsive
                :fields="tableProductColumn"
                show-empty
                empty-text="ไม่พบข้อมูลที่ค้นหา"
                class="position-relative"
              />
            </b-card-body>

          </b-card>
        </b-col>
      </b-row>

      <br>

      <!-- <invoice-list /> -->
      <orders-list :shop-id="userDatas.shopId" />
    </template>
  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BRow,
  BCol,
  BAlert,
  BLink,
  BTable,
  BBreadcrumb,
  BBreadcrumbItem,
} from 'bootstrap-vue'
import InvoiceList from '@/views/orders/invoice/invoice-list/InvoiceList.vue'
import axios, { baseURL } from '@axios'
import userStoreModule from '../userStoreModule'
import UserViewUserInfoCard from './MemberViewUserInfoCard.vue'
import UserViewUserTimelineCard from './MemberViewUserTimelineCard.vue'
import UserViewUserPermissionsCard from './MemberViewUserPermissionsCard.vue'
import OrdersList from './OrdersList.vue'
import useUsersList from './useOrdersList'

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,
    BTable,

    // Local Components
    UserViewUserInfoCard,
    UserViewUserTimelineCard,
    UserViewUserPermissionsCard,

    InvoiceList,
    OrdersList,
    BBreadcrumb,
    BBreadcrumbItem,

  },
  data() {
    return {
      productList: [],

    }
  },
  mounted() {
    this.fetchProductsByShopId()
  },
  methods: {
    fetchProductsByShopId() {
      const payload = {
        pagination: {
          total: 0,
          current: 0,
          pageSize: 500,
        },
        search: {
          name: null,
          startPrice: null,
          endPrice: null,
          shopId: router.currentRoute.params.id,
          categoryId: null,
        },
        sort: {
          predicate: 'product_name',
          reverse: true,
        },
      }
      axios
        .post(`${baseURL}/api/Product/GetList`, payload)
        .then(response => {
          this.productList = response.data.data.list
        })
    },
  },

  setup() {
    const userDatas = ref(null)

    const {
      fetchProducts,
      tableColumns,
      tableProductColumn,
      perPage,
      currentPage,
      dataMeta,
      perPageOptions,
      refUserListTable,
      refetchData,
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

    } = useUsersList()

    // const USER_APP_STORE_MODULE_NAME = "app-user";

    // // Register module
    // if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
    //   store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule);

    // // UnRegister on leave
    // onUnmounted(() => {
    //   if (store.hasModule(USER_APP_STORE_MODULE_NAME))
    //     store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    // });

    // store
    //   .dispatch("app-user/fetchUserOld", { id: 21 })
    //   .then((response) => {
    //     userData.value = response.data;
    //   })
    //   .catch((error) => {
    //     if (error.response.status === 404) {
    //       userData.value = undefined;
    //     }
    //   });
    const USER_APP_STORE_MODULE_NAME = 'seller'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) { store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule) }

    store
      .dispatch('seller/fetchUser', { id: router.currentRoute.params.id })
      .then(response => {
        userDatas.value = response.data
      })
      .catch(error => {
        if (error.response.status === 404) {
          userDatas.value = undefined
        }
      })

    return {
      userDatas,
      fetchProducts,
      tableColumns,
      tableProductColumn,
      perPage,
      currentPage,
      dataMeta,
      perPageOptions,
      refUserListTable,
      refetchData,
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.fix-minHeight-table {
  min-height: 15rem;
}
</style>
